import React from "react";

import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";

import KeyboardArrowDownIcon from "assets/icons/KeyboardArrowIcon";

const Target = () => {
  const targets = [
    { name: "Praktisi CSR, ESG, Sustainability" },
    { name: "Professional di bidang CSR, ESG, Sustainability" },
    { name: "Para Social Entrepreneurs" },
    { name: "Para pelaku Social Business" },
    {
      name: "Para pelaku UKM yang memilik niat untuk mengintegrasikan Sustainability dalam Bisnisnya",
    },
    {
      name: "Para generasi muda (Millenial, Gen Z, Gen A, dll) yang memiliki niat untuk menjadi praktisi dan professional di bidang Sustainability",
    },
    {
      name: "Siapapun yang memiliki niat untuk berkontribusi kepada pencapaian SDGs (Sustainable Development Goals) melalui semua tindakannya dan pekerjaannya.",
    },
  ];

  const AccordionItem = ({ header, order, ...rest }) => {
    return (
      <Item
        {...rest}
        header={({ state: { isEnter } }) => (
          <div className="flex flex-row items-center gap-4">
            <div className="flex gap-3 pt-3 pb-4 space-y-6 md:pt-6 md:pb-8">
              <p className="text-xl font-bold text-start sm:text-2xl app-animation-translate-start">
                {header}
              </p>
            </div>
            <div>
              <KeyboardArrowDownIcon
                className={`h-4 md:h-6 xl:h-8 w-2 md:w-4 xl:w-6 ml-auto fill-black transition-transform duration-200 ease-out mt-[-0.25em] ${
                  isEnter && "rotate-180"
                }`}
              />
            </div>
          </div>
        )}
        className={""}
        buttonProps={{
          className: ({ isEnter }) => `w-full text-left`,
        }}
        contentProps={{
          className: "transition-height duration-200 ease-out",
        }}
        panelProps={{ className: "" }}
        initialEntered={false}
      />
    );
  };

  return (
    <div className="space-y-8 app-main-container">
      <Accordion
        className="flex items-center app-animation-scale-start"
        transition
        transitionTimeout={200}
      >
        <AccordionItem header={"Siapa yang perlu mengikuti ini ?"}>
          <div className="grid grid-cols-1 gap-5 pt-2">
            {targets.map((target, i) => {
              return (
                <div
                  key={i}
                  className="rounded-lg app-animation-translate-start"
                >
                  <div className="app-animation-translate-start">
                    <p className="text-base font-bold md:text-lg xl:text-xl">
                      {i + 1}. {target.name}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Target;
